/* eslint-disable */

import * as $ from "jquery";
// VERSION 0.184.7149--7/29/2019 09:41:16--

// FILE--7/29/2019 09:41:16--main

function createObject(proto) {
    function ctor() {}
    ctor.prototype = proto;
    return new ctor();
}

var portima = portima || {};
portima.main = portima.main || {};
portima.main.fErr = function (ctxt, descr, cat) {
    return { ctxt, descr, cat };
};
// fmt
if (!String.prototype.fmt) {
    String.prototype.fmt = function () {
        const args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != "undefined" ? args[number] : match;
        });
    };
}

if (!String.prototype.encodeHTML) {
    String.prototype.encodeHTML = function () {
        return this.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
    };
}

Date.NowUtc = function () {
    const vDate = new Date();
    let m = vDate.getUTCMonth() + 1;
    m = m < 10 ? `0${m}` : m;
    let d = vDate.getUTCDate();
    d = d < 10 ? `0${d}` : d;
    let h = vDate.getUTCHours();
    h = h < 10 ? `0${h}` : h;
    let mi = vDate.getUTCMinutes();
    mi = mi < 10 ? `0${mi}` : mi;
    let s = vDate.getSeconds();
    s = s < 10 ? `0${s}` : s;
    return "y-m-dTh:mi:sZ"
        .replace("y", vDate.getUTCFullYear())
        .replace("m", m)
        .replace("d", d)
        .replace("h", h)
        .replace("mi", mi)
        .replace("s", s);
};

if (typeof Object.assign != "function") {
    Object.assign = function (target) {
        if (target == null) {
            throw new TypeError("Cannot convert undefined or null to object");
        }

        target = Object(target);
        for (let index = 1; index < arguments.length; index++) {
            const source = arguments[index];
            if (source != null) {
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

portima.main.isMobile = {
    Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any(bMobile) {
        const v = portima.main.isMobile;
        if (bMobile != undefined) return bMobile;
        return v.Android() || v.BlackBerry() || v.iOS() || v.Opera() || v.Windows();
    },
};

portima.main.log = portima.main.log || {};
portima.main.log.LEVELS = {
    all: -1,
    verbose: 10000,
    trace: 20000,
    debug: 30000,
    info: 40000,
    notice: 50000,
    warn: 60000,
    error: 70000,
    severe: 80000,
    critical: 90000,
    fatal: 110000,
    emergency: 120000,
    off: 0x7fffffff,
};
portima.main.log.levelMin = portima.main.log.LEVELS.all;
portima.main.log.data = function (data) {
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin) return data;
    return "...";
};

portima.main.ver2int = function (ver) {
    let i;
    const a = ver.split(".");

    i = a[0] * 1;
    if (a.length > 1) {
        i = Math.pow(i, 16) + a[1] * 1;
    }
    return i;
};

portima.main.generateUUID = function () {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};

// FILE--7/29/2019 09:41:16--wskMain

portima.wsk = portima.wsk || {};

// portima.wsk.CConn
portima.wsk.m_gFqdn = "127.0.0.1"; // 127.0.0.1 local.wsk.portima.be
const a = navigator.userAgent.match(/(Mozilla?)|(Windows?)|(Chrome?)/i);
// if (a && a[1] >= 72) portima.wsk.m_gFqdn = "goblins.wsk.portima.be";
portima.wsk.m_gvExpected = { e: "0", w: "0" };
portima.wsk.m_gvCurrent = null;
portima.wsk.fVerCheck = function (oVer) {
    if (!portima.wsk.m_gvCurrent) return "";
    if (!oVer) oVer = portima.wsk.m_gvExpected;
    if (
        portima.main.ver2int(portima.wsk.m_gvCurrent.e) < portima.main.ver2int(oVer.e) ||
        portima.main.ver2int(portima.wsk.m_gvCurrent.w) < portima.main.ver2int(oVer.w)
    )
        return "mismatch WSK version: {0}/{1} expected but {2}/{3}".fmt(
            oVer.e,
            oVer.w,
            portima.wsk.m_gvCurrent.e,
            portima.wsk.m_gvCurrent.w,
        );
    return "";
};
portima.wsk.fVerSet = function (str) {
    if (!str) {
        portima.wsk.m_gvCurrent = { e: "0.1", w: "0.1" };
        return;
    }
    str = /e(.*)\..*\..*\/w(.*)\..*\..*/g.exec(str);
    portima.wsk.m_gvCurrent = { e: str[1], w: str[2] };
};

portima.wsk.fQuery = function (obj) {
    let strSec = "";

    if (obj.sec && obj.sec.m_bAuth) {
        strSec = '<sec bAuth="1" artifact="{0}" token ="{1}"/>'.fmt(obj.sec.m_strArtifact, obj.sec.m_strToken);
    }
    return '<?xml version="1.0" encoding="utf-8" ?>\
<req xmlns="{0}" version="0.1" id="{1}" func="{2}" dt="{3}">\
<header host="{4}"/>{5}<param goblVers="0.184"{6}>{7}</param></req>'.fmt(
        obj.ns,
        1,
        obj.func,
        Date.NowUtc(),
        "WS Browser",
        strSec,
        obj.extra ? obj.extra : "",
        obj.param,
    );
};
portima.wsk.CConn = function portimaWskCConn(tcp, param) {
    param = param || {};
    param.timeoutIdle = param.timeoutIdle == undefined ? -1 : param.timeoutIdle;
    this.m_strObjId = portima.main.generateUUID();
    if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
        console.log("%s::new START %s", this.constructor.name, this.m_strObjId);
    this.m_strState = "START"; // START,CONNECTING,CONNECTED,REQ
    this.m_ip = 0;
    this.m_tcp = tcp;
    this.m_ns = null;
    this.m_timeoutIdle = param.timeoutIdle;
    this.m_WebSocket = null;
    this.m_strXml = null;
    this.m_vCtxt = null;
    this.m_vHashSubscr = {};
    this.m_vDeferred = null;
    this.m_vSec = { m_bAuth: 0, m_strToken: "", m_strArtifact: "", m_strSp: "" };
};
portima.wsk.CConn.prototype.fCloseSilent = function () {
    this.m_strState = "START";
    if (!this.m_WebSocket) return;
    this.m_WebSocket.onclose = null;
    this.m_WebSocket.close();
    this.m_WebSocket = null;
};
portima.wsk.CConn.prototype.fErr = function (strFunc, strDescr, strCategory) {
    strFunc = "{0}::{1}".fmt(this.constructor.name, strFunc);
    return portima.main.fErr(strFunc, strDescr, strCategory || "middleware");
};
portima.wsk.CConn.prototype.fErrInReq = function (strFunc, strDescr, strCategory) {
    if (!this.m_vDeferred || this.m_vDeferred.state() != "pending") this.m_vDeferred = $.Deferred();
    this.fResultReject(this.fErr(strFunc, strDescr, strCategory));
    return this.m_vDeferred.promise();
};

portima.wsk.CConn.prototype.fPushChck = function (vCRes) {
    return null;
};

portima.wsk.CConn.prototype.fQuery = function (obj) {
    let str = "";

    obj = obj || {};
    if (this.m_timeoutIdle >= 0) str += ' timeoutIdle="{0}"'.fmt(this.m_timeoutIdle);
    if (str) obj.extra = str;
    if (this.m_ns) obj.ns = this.m_ns;
    if (this.m_vSec && this.m_vSec.m_bAuth) obj.sec = this.m_vSec;
    return portima.wsk.fQuery(obj);
};

portima.wsk.CConn.prototype.fReq = function (strXml) {
    let str;

    if (strXml) this.m_vDeferred = $.Deferred();
    if (this.m_strState != "START" && this.m_strState != "CONNECTED") {
        this.fResultReject(this.fErr("fReq", "{0} is an unexpected state".fmt(this.m_strState)));
        return this.m_vDeferred.promise();
    }
    if (strXml) this.m_strXml = strXml;
    if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
        console.log(
            "%s::fReq %s tcp=%s xml=[%s]",
            this.constructor.name,
            this.m_strState,
            this.m_tcp,
            portima.main.log.data(strXml),
        );
    str = portima.wsk.fVerCheck();
    if (str) {
        this.fResultReject(this.fErr("fReq", str));
        return this.m_vDeferred.promise();
    }
    const tcp = this.m_tcp;
    if (!this.m_tcp && !(this.m_tcp = this.fTcp())) return this.m_vDeferred.promise();
    if (!tcp)
        if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
            console.log("%s::fReq %s found tcp=%s", this.constructor.name, this.m_strState, this.m_tcp);
    if (this.m_strState == "START" || this.m_WebSocket.readyState != 1) {
        const strUrl = "wss://{0}:{1}".fmt(this.m_ip ? this.m_ip : portima.wsk.m_gFqdn, this.m_tcp);
        this.m_strState = "CONNECTING";
        if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
            console.log("%s::fReq %s url=%s", this.constructor.name, this.m_strState, strUrl);
        try {
            this.m_WebSocket = new WebSocket(strUrl);
        } catch (e) {
            this.fResultReject(this.fErr("fReq", "error [{0}] when new WebSocket".fmt(e)));
            return this.m_vDeferred.promise();
        }

        const self = this;
        this.m_WebSocket.onclose = function (e) {
            self.onclose(e);
        };
        this.m_WebSocket.onerror = function (e) {
            self.onerror(e);
        };
        this.m_WebSocket.onmessage = function (e) {
            self.onmessage(e);
        };
        this.m_WebSocket.onopen = function (e) {
            self.onopen(e);
        };
        return this.m_vDeferred.promise();
    }
    if (this.m_strXml == "_portima.wsk.CConn.local.tcp") {
        this.fResultResolve({ tcp: this.m_tcp });
        return this.m_vDeferred.promise();
    }
    this.m_strState = "REQ";
    if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
        console.log(
            "%s::fReq CONNECTED to REQ sending [%s]",
            this.constructor.name,
            portima.main.log.data(this.m_strXml),
        );
    this.m_WebSocket.send(this.m_strXml);
    return this.m_vDeferred.promise();
};
portima.wsk.CConn.prototype.fResultCheckPre = function (xml) {
    return "";
};
portima.wsk.CConn.prototype.fResultReject = function (vCErr) {
    this.fResultUpdateErr(vCErr);
    if (this.m_vDeferred) this.m_vDeferred.rejectWith(this, [vCErr]);
};
portima.wsk.CConn.prototype.fResultResolve = function (vCRes) {
    this.fResultUpdateOk(vCRes);
    if (this.m_vDeferred) {
        if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
            console.log("%s::fResultResolve %s", this.constructor.name, this.m_strObjId);
        this.m_vDeferred.resolveWith(this, [vCRes]);
    }
};
portima.wsk.CConn.prototype.fResultUpdateErr = function (vCErr) {
    return vCErr;
};
portima.wsk.CConn.prototype.fResultUpdateOk = function (vCRes) {
    return vCRes;
};
portima.wsk.CConn.prototype.fTcp = function () {
    return 0;
};
portima.wsk.CConn.prototype.onclose = function (e) {
    const str = "(code={0} reason={1})".fmt(e.code, e.reason);
    switch (this.m_strState) {
        case "CONNECTED":
            var vCErr = this.fErr("onclose", "while connected {0}".fmt(str));
            this.fResultReject(vCErr);
            if (this.m_fOkPush) this.m_fOkPush(vCErr);
            break;
        case "CONNECTING":
            this.fResultReject(this.fErr("onclose", "while connecting {0}".fmt(str)));
            break;
        case "REQ":
            this.fResultReject(this.fErr("onclose", "while requesting {0}".fmt(str)));
            break;
        case "START":
            this.fResultReject(this.fErr("onclose", "state START is impssible in that context {0}".fmt(str)));
            break;
    }
    this.m_strState = "START";
    this.m_WebSocket = null;
    if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
        console.log("%s::onclose reset to START", this.constructor.name);
};
portima.wsk.CConn.prototype.onerror = function (e) {
    switch (this.m_strState) {
        case "CONNECTED":
            this.fResultReject(this.fErr("onerror", "while connected"));
            break;
        case "CONNECTING":
            this.fResultReject(this.fErr("onerror", `while connecting to ${this.m_WebSocket.url}`));
            break;
        case "REQ":
            this.fResultReject(this.fErr("onerror", "while requesting"));
            break;
        case "START":
            this.fResultReject(this.fErr("onerror", "state START is impssible in that context"));
            break;
    }
    this.fCloseSilent();
    if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
        console.log("%s::onerror reset to START", this.constructor.name);
};
portima.wsk.CConn.prototype.onmessage = function (e) {
    let str;

    if (this.m_strState != "REQ" && this.m_strState != "CONNECTED") {
        if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
            console.log("%s::onmessage unexpected state %s", this.constructor.name, this.m_strState);
        this.fResultReject(this.fErr("onmessage", "{0} is an unexpected state".fmt(this.m_strState)));
        this.fCloseSilent();
        return;
    }
    const $xml = $($.parseXML(e.data));
    str = this.fResultCheckPre($xml);
    if (str) {
        this.m_strState = "CONNECTED";
        if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
            console.log("%s::onmessage APPLICATIVE ERROR REQ->CONNECTED res=[%s]", this.constructor.name, e.data);
        this.fResultReject(this.fErr("onmessage", str, "applicative"));
        return;
    }
    const err = $xml.find("res > errors > error");
    if (err.length) {
        this.m_strState = "CONNECTED";
        if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
            console.log("%s::onmessage APPLICATIVE ERROR REQ->CONNECTED res=[%s]", this.constructor.name, e.data);
        this.fResultReject(this.fErr("onmessage", $(err).find("descr").text(), "applicative"));
        return;
    }
    const vCRes = {};
    vCRes.main = {};
    var v = $xml.find("res");
    const vMain = vCRes.main;
    vMain.xml = $xml;
    vMain.ctxt = this.m_vCtxt;
    vMain.resRaw = e.data;
    vMain.func = v.attr("func");
    vMain.ns = v.attr("xmlns");
    var v = this.fPushChck(vCRes);
    if (!v) {
        if (this.m_strState != "REQ") {
            if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
                console.log("%s::onmessage unexpected state %s", this.constructor.name, this.m_strState);
            this.fResultReject(this.fErr("onmessage", "{0} is an unexpected state".fmt(this.m_strState)));
            this.fCloseSilent();
            return;
        }
        this.m_strState = "CONNECTED";
        if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
            console.log("%s::onmessage REQ->CONNECTED res=[%s]", this.constructor.name, portima.main.log.data(e.data));
        vMain.reqRaw = this.m_strXml;
        return this.fResultResolve(vCRes);
    }
    const fOkPush = this.m_vHashSubscr[v];
    if (!fOkPush) {
        if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
            console.log(
                "%s::onmessage %s PUSH IGNORED id=%s res=[%s]",
                this.constructor.name,
                this.m_strState,
                v,
                e.data,
            );
        return;
    }
    if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
        console.log(
            "%s::onmessage %s PUSH OK id=%s res=[%s]",
            this.constructor.name,
            this.m_strState,
            v,
            portima.main.log.data(e.data),
        );
    vMain.guidSubscr = v;
    this.fResultResolve(vCRes);
};
portima.wsk.CConn.prototype.onopen = function (e) {
    if (this.m_strState == "CONNECTING") {
        this.m_strState = "CONNECTED";
        if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
            console.log("%s::onopen CONNECTING to CONNECTED", this.constructor.name);
        this.fReq(null);
        return;
    }
    if (portima.main.log.LEVELS.error >= portima.main.log.levelMin)
        console.log("%s::onopen unexpected state %s", this.constructor.name, this.m_strState);
    this.fResultReject(this.fErr("onopen", "{0} is an unexpected state".fmt(this.m_strState)));
    this.fCloseSilent();
};

// portima.wsk.CConnGlob
portima.wsk.CConnGlob = function portimaWskCConnGlob() {
    portima.wsk.CConn.call(this, portima.wsk.m_gFqdn == "127.0.0.1" ? 10219 : 10220);
};
portima.wsk.CConnGlob.prototype = createObject(portima.wsk.CConn.prototype);
portima.wsk.CConnGlob.prototype.constructor = portima.wsk.CConnGlob;

portima.wsk.CConnGlob.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/glob/gen";
portima.wsk.CConnGlob.prototype.m_gaQuery = {};
portima.wsk.CConnGlob.prototype.m_gaQuery.fTcpPortGet = {
    ns: portima.wsk.CConnGlob.prototype.m_gNs,
    func: "fTcpPortGet",
    param: "",
};

// portima.wsk.CConnSess
portima.wsk.CConnSess = function portimaWskCConnSess(param) {
    portima.wsk.CConn.call(this, 0, param);
    this.m_vCConnGlob = null;
};
portima.wsk.CConnSess.prototype = createObject(portima.wsk.CConn.prototype);
portima.wsk.CConnSess.prototype.constructor = portima.wsk.CConnSess;
portima.wsk.CConnSess.m_gTcp = 0;
portima.wsk.CConnSess.prototype.fTcp = function () {
    if (portima.wsk.CConnSess.m_gTcp) return portima.wsk.CConnSess.m_gTcp;
    this.m_strState = "START";
    const self = this;
    this.m_vCConnGlob = new portima.wsk.CConnGlob();
    this.m_vCConnGlob.fReq(portima.wsk.fQuery(this.m_vCConnGlob.m_gaQuery.fTcpPortGet)).then(
        function (vCRes) {
            let str = "";
            if (portima.wsk.m_gFqdn != "127.0.0.1") str = vCRes.main.xml.find("res > param > info").attr("tcpPortDom");
            if (str && str > 0) portima.wsk.CConnSess.m_gTcp = str;
            else portima.wsk.CConnSess.m_gTcp = vCRes.main.xml.find("res > param > info").attr("tcpPort");
            portima.wsk.fVerSet(vCRes.main.xml.find("res > param > info").attr("v"));
            self.m_vCConnGlob.fCloseSilent();
            if (portima.main.log.LEVELS.info >= portima.main.log.levelMin)
                console.log("%s is CLOSED", this.constructor.name);
            self.m_vCConnGlob = null;
            self.fReq(null);
        },
        function (vCErr) {
            self.fResultReject(vCErr);
        },
    );
    return 0;
};
portima.wsk.CConnSess.prototype.fWsTcpGet = function () {
    return this.fReq("_portima.wsk.CConn.local.tcp");
};
// FILE--7/29/2019 09:41:16--wskWsApdu

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.apdu = portima.wsk.ws.apdu || {};

// portima.wsk.ws.apdu.CConnSess
portima.wsk.ws.apdu.CConnSess = function portimaWskWsApduCConnSess() {
    portima.wsk.CConnSess.call(this);
};
portima.wsk.ws.apdu.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.apdu.CConnSess.prototype.constructor = portima.wsk.ws.apdu.CConnSess;

portima.wsk.ws.apdu.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let v;
    let v0;
    let x;

    vCRes.cmdsIn = this.m_cmdsIn;
    vCRes.cmdsOut = [];
    v = $(vCRes.main.xml.find("res>param>cmds"));
    vCRes.cmdsOut.info = { reader: v.attr("reader"), bPinpad: v.attr("bPinpad") };
    v = vCRes.main.xml.find("res>param>cmds>cmd");
    for (let i = 0; i < v.length; i++) {
        v0 = $(v[i]);
        vCRes.cmdsOut[i] = { name: v0.attr("name"), out: null, err: null };
        x = v0.find("out");
        if (x.length > 0) vCRes.cmdsOut[i].out = $(x[0]).text();
        x = v0.find("error");
        if (x.length > 0) {
            x = $(x);
            vCRes.cmdsOut[i].err = { ctxt: $(x.find("ctxt")).text(), descr: $(x.find("descr")).text() };
        }
    }
    return vCRes;
};

// WS API
portima.wsk.ws.apdu.CConnSess.prototype.fCmdsExec = function (str) {
    let $xml;
    let v;
    let v0;
    let x;

    this.m_vDeferred = null;
    if (!str) return this.fErrInReq("fCmdsExec", "empty cmds", "applicative");
    try {
        $xml = $($.parseXML(str));
    } catch (e) {
        return this.fErrInReq("fCmdsExec", "invalid xml", "applicative");
    }
    this.m_cmdsIn = [];
    v = $xml.find("cmds>cmd");
    for (let i = 0; i < v.length; i++) {
        v0 = $(v[i]);
        this.m_cmdsIn[i] = {
            name: v0.attr("name"),
            aClsIns: v0.attr("aClsIns"),
            bOut: v0.attr("bOut") == 1 ? 1 : 0,
            in: null,
        };
        x = v0.find("in");
        if (x.length > 0) this.m_cmdsIn[i].in = $(x[0]).text();
    }
    return this.fReq(portima.wsk.fQuery(this.m_gaQuery.fCmdsExec).fmt(str));
};

// XML API
portima.wsk.ws.apdu.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/apdu";
portima.wsk.ws.apdu.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.apdu.CConnSess.prototype.m_gaQuery.fCmdsExec = {
    ns: portima.wsk.ws.apdu.CConnSess.prototype.m_gNs,
    func: "fCmdsExec",
    param: "{0}",
};

// FILE--7/29/2019 09:41:16--wskWsBot

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.bot = portima.wsk.ws.bot || {};

// portima.wsk.ws.bot.CConnSess
portima.wsk.ws.bot.CConnSess = function portimaWskWsBotCConnSess() {
    portima.wsk.CConnSess.call(this);
};
portima.wsk.ws.bot.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.bot.CConnSess.prototype.constructor = portima.wsk.ws.bot.CConnSess;

portima.wsk.ws.bot.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let v;
    let v0;
    let x;

    return vCRes;
};

// WS API
portima.wsk.ws.bot.CConnSess.prototype.fUserSet = function (o, so, pkgId, pkgUser, lang) {
    let $xml;
    let v;
    let v0;
    let x;

    this.m_vDeferred = null;
    if (!o || !so) return this.fErrInReq("fUserSet", "empty o or so", "applicative");
    return this.fReq(portima.wsk.fQuery(this.m_gaQuery.fUserSet).fmt(o, so, pkgId, pkgUser, lang));
};

// XML API
portima.wsk.ws.bot.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/bot";
portima.wsk.ws.bot.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.bot.CConnSess.prototype.m_gaQuery.fUserSet = {
    ns: portima.wsk.ws.bot.CConnSess.prototype.m_gNs,
    func: "fUserSet",
    param: '<info o="{0}" so="{1}" pkgId="{2}" pkgUser="{3}" lang="{4}"/>',
};

// FILE--7/29/2019 09:41:16--wskWsCom

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.com = portima.wsk.ws.com || {};

// portima.wsk.ws.com.CConnSess
portima.wsk.ws.com.CConnSess = function portimaWskWsComCConnSess(param) {
    portima.wsk.CConnSess.call(this, param);
    this.m_ver2Test = { e: "0.111", w: "0.139" };
    this.m_WrapProgId = "";
};
portima.wsk.ws.com.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.com.CConnSess.prototype.constructor = portima.wsk.ws.com.CConnSess;

portima.wsk.ws.com.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let i;
    var v;
    let v0;
    let str;
    let vMain;
    let n;
    let t;

    vMain = vCRes.main;
    if (vMain.func == "fCreateExchRelease" || vMain.func == "fExch") {
        vCRes.paramsIn = this._input;
        vCRes.paramsOut = {};
        var v = vMain.xml.find("res>param>ps>p");
        for (let i = 0; i < v.length; i++) {
            v0 = $(v[i]);
            t = v0.attr("t");
            n = v0.attr("n");
            str = v0.text();
            switch (t) {
                case "s":
                    break;
                case "b":
                    str = str == "1";
                    break;
                case "d":
                case "i":
                    str *= 1;
                    break;
            }
            vCRes.paramsOut[n] = str;
        }
    } else if (vMain.func == "fCreate") vCRes.guid = vMain.xml.find("res > param > info").attr("guid");
    return vCRes;
};

// WS API
portima.wsk.ws.com.CConnSess.prototype.fCreate = function (progId) {
    if (!progId) return this.fErrInReq("fCreate", "empty progId", "applicative");
    return this.fReq(this.fQuery(this.m_gaQuery.fCreate).fmt(progId));
};
portima.wsk.ws.com.CConnSess.prototype.fCreateExchRelease = function (progId, f) {
    const str = portima.wsk.ws.com.CConnSess.paramsCreate(arguments);
    this._input = { p: progId, f };
    return this.fReq(this.fQuery(this.m_gaQuery.fCreateExchRelease).fmt(progId, f, str));
};

portima.wsk.ws.com.CConnSess.prototype.fWrapCreate = function (url, ver, progId) {
    return this.fWrapCreateExchRelease(url, ver, progId, "__");
};

portima.wsk.ws.com.CConnSess.prototype.fWrapCreateExchRelease = function (url, ver, progId, f) {
    const self = this;

    this.m_call = {
        connGlob: new portima.wsk.ws.glob.install.CConnGlob(),
        deferrer: $.Deferred(),
        progId: `${progId},${progId},${ver}`,
    };
    this.fCall = function (progId, f, arguments0, bInvoke, bNew) {
        if (bInvoke) {
            self.m_call.connGlob = null;
            if (bNew) arguments0[0] = self.m_call.progId;
            console.log(
                "%s::fWrapCreateExchRelease INVOKING %s %s::%s",
                this.constructor.name,
                bNew ? ".NET" : "COM",
                progId,
                f,
            );
            const m_WrapProgId = arguments0[0];
            if (f == "__")
                self.fCreate.apply(self, arguments0).then(
                    function (vCRes) {
                        vCRes.wrapProgId = arguments0[0];
                        self.m_call.deferrer.resolveWith(self, [vCRes]);
                    },
                    function (vCErr) {
                        self.m_call.deferrer.rejectWith(self, [vCErr]);
                    },
                );
            else
                self.fCreateExchRelease.apply(self, arguments0).then(
                    function (vCRes) {
                        vCRes.wrapProgId = arguments0[0];
                        self.m_call.deferrer.resolveWith(self, [vCRes]);
                    },
                    function (vCErr) {
                        self.m_call.deferrer.rejectWith(self, [vCErr]);
                    },
                );
            return;
        }
        console.log(
            "%s::fWrapCreateExchRelease CHECKING %s %s::%s",
            this.constructor.name,
            bNew ? ".NET" : "COM",
            progId,
            f,
        );
        self.m_call.connGlob.fInstall(bNew ? self.m_call.progId : progId, ver, url, 0).then(
            function () {
                self.fCall(progId, f, arguments0, true, bNew);
            },
            function (vCErr) {
                if (vCErr.cat == "middleware") {
                    self.m_call.deferrer.rejectWith(self, [vCErr]);
                    return;
                }
                if (bNew && (!portima.wsk.m_gvCurrent || portima.wsk.fVerCheck(self.m_ver2Test))) {
                    console.log(
                        "%s::fWrapCreateExchRelease REVERT TO COM %s %s::%s",
                        this.constructor.name,
                        bNew ? ".NET" : "COM",
                        progId,
                        f,
                    );
                    self.fCall(progId, f, arguments0, false, false);
                    return;
                }
                console.log(
                    "%s::fWrapCreateExchRelease INSTALLING %s %s::%s",
                    this.constructor.name,
                    bNew ? ".NET" : "COM",
                    progId,
                    f,
                );
                self.m_call.connGlob.fInstall(bNew ? self.m_call.progId : progId, ver, url, 2).then(
                    function () {
                        self.fCall(progId, f, arguments0, true, bNew);
                    },
                    function (vCErr) {
                        self.m_call.deferrer.rejectWith(self, [vCErr]);
                    },
                );
            },
        );
    };
    this.fCall(progId, f, Array.from(arguments).slice(2), false, true);
    return this.m_call.deferrer.promise();
};
portima.wsk.ws.com.CConnSess.prototype.fCreateExchReleaseRaw = function (str) {
    const $xml = $($.parseXML(str));
    const v = $xml.find("ps");
    const progId = v.attr("progId");
    const f = v.attr("f");
    str = str.substring(str.indexOf(">") + 1, str.lastIndexOf("</ps>"));
    this._input = { p: progId, f };
    return this.fReq(this.fQuery(this.m_gaQuery.fCreateExchRelease).fmt(progId, f, str));
};
portima.wsk.ws.com.CConnSess.prototype.fExch = function (guid, f) {
    const str = portima.wsk.ws.com.CConnSess.paramsCreate(arguments);
    this._input = { f };
    return this.fReq(portima.wsk.fQuery(this.m_gaQuery.fExch).fmt(guid, f, str));
};
portima.wsk.ws.com.CConnSess.prototype.fExchRaw = function (guid, str) {
    const $xml = $($.parseXML(str));
    const v = $xml.find("ps");
    const f = v.attr("f");
    str = str.substring(str.indexOf(">") + 1, str.lastIndexOf("</ps>"));
    this._input = { f };
    return this.fReq(portima.wsk.fQuery(this.m_gaQuery.fExch).fmt(guid, f, str));
};
portima.wsk.ws.com.CConnSess.prototype.fRelease = function (guid) {
    if (!guid) return this.fErrInReq("fRelease", "empty guid", "applicative");
    return this.fReq(portima.wsk.fQuery(this.m_gaQuery.fRelease).fmt(guid));
};

// XML API
portima.wsk.ws.com.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/com";
portima.wsk.ws.com.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.com.CConnSess.prototype.m_gaQuery.fCreate = {
    ns: portima.wsk.ws.com.CConnSess.prototype.m_gNs,
    func: "fCreate",
    param: '<info progId="{0}"/>',
};
portima.wsk.ws.com.CConnSess.prototype.m_gaQuery.fCreateExchRelease = {
    ns: portima.wsk.ws.com.CConnSess.prototype.m_gNs,
    func: "fCreateExchRelease",
    param: '<ps progId="{0}" f="{1}">{2}</ps>',
};
portima.wsk.ws.com.CConnSess.prototype.m_gaQuery.fExch = {
    ns: portima.wsk.ws.com.CConnSess.prototype.m_gNs,
    func: "fExch",
    param: '<ps guid="{0}" f="{1}">{2}</ps>',
};
portima.wsk.ws.com.CConnSess.prototype.m_gaQuery.fRelease = {
    ns: portima.wsk.ws.com.CConnSess.prototype.m_gNs,
    func: "fRelease",
    param: '<info guid="{0}"/>',
};

portima.wsk.ws.com.CConnSess.paramsCreate = function (a) {
    let i;
    let str = "";

    if (a.length >= 3)
        for (i = 2; i < a.length; i++) {
            var str0;
            var t;
            var v;
            var d;
            var n;
            var v0;

            v = a[i];
            t = "s";
            d = "i";
            n = "";
            str0 = typeof v;
            switch (str0) {
                case "string":
                    break;
                case "boolean":
                    t = "b";
                    v = v ? "1" : "0";
                    break;
                case "number":
                    t = v % 1 > 0 ? "d" : "i";
                    break;
                case "object": {
                    v0 = v.t;
                    if (v0) t = v0;
                    v0 = v.d;
                    if (v0) d = v0;
                    v0 = v.n;
                    if (v0) n = v0;
                    v0 = v.v;
                    v = v0 || "";
                    break;
                }
            }
            if (n != "") n = ' n="{0}"'.fmt(n);
            str += '<p t="{0}" d="{1}"{2}>{3}</p>'.fmt(
                t,
                d,
                n,
                t == "s" && v != "" ? "<![CDATA[{0}]]>".fmt(v.replace(/\]\]\>/g, "]]]]><![CDATA[>")) : v,
            );
        }
    return str;
};
// FILE--7/29/2019 09:41:16--wskWsGlobInstall

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.glob = portima.wsk.ws.glob || {};
portima.wsk.ws.glob.install = portima.wsk.ws.glob.install || {};

// portima.wsk.ws.glob.install.CConnGlob
portima.wsk.ws.glob.install.CConnGlob = function portimaWskWsGlobInstallCConnGlob() {
    portima.wsk.CConnGlob.call(this);
};
portima.wsk.ws.glob.install.CConnGlob.prototype = createObject(portima.wsk.CConnGlob.prototype);
portima.wsk.ws.glob.install.CConnGlob.prototype.constructor = portima.wsk.ws.glob.install.CConnGlob;

portima.wsk.ws.glob.install.CConnGlob.prototype.fResultUpdateErr = function (vCErr) {
    if (vCErr.descr.match(/(^e.*\/w.*?)--/)) {
        portima.wsk.fVerSet(vCErr.descr.split("--")[0]);
    }
    return vCErr;
};

portima.wsk.ws.glob.install.CConnGlob.prototype.fResultUpdateOk = function (vCRes) {
    return vCRes;
};

// WS API
portima.wsk.ws.glob.install.CConnGlob.prototype.fInstall = function (progId, ver, url, byMode) {
    this.m_vDeferred = null;
    if (!progId) return this.fErrInReq("fInstall", "empty progId", "applicative");
    if (!ver) ver = "";
    if (!url) url = "";
    const str = portima.wsk.fQuery(this.m_gaQuery.fInstall).fmt(progId, ver, url, byMode);
    return this.fReq(str);
};
portima.wsk.ws.glob.install.CConnGlob.prototype.fPkgSwitch = function (progId, bGloblins, browser, url) {
    this.m_vDeferred = null;
    if (!progId) return this.fErrInReq("fPkgSwitch", "empty progId", "applicative");
    bGloblins = bGloblins ? 1 : 0;
    browser = browser || "";
    url = url || "";
    const str = portima.wsk.fQuery(this.m_gaQuery.fPkgSwitch).fmt(progId, bGloblins, browser, url);
    return this.fReq(str);
};

// XML API
portima.wsk.ws.glob.install.CConnGlob.prototype.m_gNs =
    "http://www.portima.com/pki/identity/pi2/local/asweb/glob/install";
portima.wsk.ws.glob.install.CConnGlob.prototype.m_gaQuery = {};
portima.wsk.ws.glob.install.CConnGlob.prototype.m_gaQuery.fInstall = {
    ns: portima.wsk.ws.glob.install.CConnGlob.prototype.m_gNs,
    func: "fInstall",
    param: '<info progId="{0}" ver="{1}" url="{2}" byMode="{3}"/>',
};
portima.wsk.ws.glob.install.CConnGlob.prototype.m_gaQuery.fPkgSwitch = {
    ns: portima.wsk.ws.glob.install.CConnGlob.prototype.m_gNs,
    func: "fPkgSwitch",
    param: '<info progId="{0}" bGoblins="{1}" browser="{2}" url="{3}"/>',
};

// FILE--7/29/2019 09:41:16--wskWsMgtCred

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.mgtCred = portima.wsk.ws.mgtCred || {};

// portima.wsk.ws.bot.CConnSess
portima.wsk.ws.mgtCred.CConnSess = function portimaWskWsMgtCredCConnSess() {
    portima.wsk.CConnSess.call(this);
};
portima.wsk.ws.mgtCred.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.mgtCred.CConnSess.prototype.constructor = portima.wsk.ws.mgtCred.CConnSess;

portima.wsk.ws.mgtCred.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    return vCRes;
};

// WS API
portima.wsk.ws.mgtCred.CConnSess.prototype.fMobOrder = function (o) {
    this.m_vDeferred = null;
    if (!o.urlSp || !o.sessTok || !o.guidPp || !o.user)
        return this.fErrInReq("fMobOrder", "empty urlSp or sessTok or guidPp or user", "applicative");
    if (!o.user.lname || !o.user.fname || !o.user.sex || !o.user.langue)
        return this.fErrInReq("fMobOrder", "empty user { lname or fname or sex or langue }", "applicative");
    if (!o.user.email && !o.user.gsm) return this.fErrInReq("fMobOrder", "empty user { email and gsm }", "applicative");
    o.user.email = o.user.email || "";
    o.user.gsm = o.user.gsm || "";
    const strUser = '<user fname="{0}" lname="{1}" sex="{2}" langue="{3}" email="{4}" gsm="{5}"/>'.fmt(
        o.user.fname,
        o.user.lname,
        o.user.sex,
        o.user.langue,
        o.user.email,
        o.user.gsm,
    );
    return this.fReq(
        portima.wsk.fQuery(this.m_gaQuery.fMobOrder).fmt(o.urlSp, o.sessTok, o.guidPp, o.o, o.bDcNew ? 1 : 0, strUser),
    );
};

// XML API
portima.wsk.ws.mgtCred.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/mgtCred";
portima.wsk.ws.mgtCred.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.mgtCred.CConnSess.prototype.m_gaQuery.fMobOrder = {
    ns: portima.wsk.ws.mgtCred.CConnSess.prototype.m_gNs,
    func: "fMobOrder",
    param: '<info urlSp="{0}" sessTok="{1}" guidPp="{2}" o="{3}" bDcNew="{4}" />{5}',
};

// FILE--7/29/2019 09:41:16--wskWsMsg

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.msg = portima.wsk.ws.msg || {};

// portima.wsk.ws.msg.CConnSess
portima.wsk.ws.msg.CConnSess = function portimaWskWsMsgCConnSess(param) {
    portima.wsk.CConnSess.call(this, param);
};
portima.wsk.ws.msg.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.msg.CConnSess.prototype.constructor = portima.wsk.ws.msg.CConnSess;

portima.wsk.ws.msg.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let i;
    let str;
    let v;
    let v0;
    let v1;
    const vMain = vCRes.main;

    if (["fDump", "fPost", "fReadNext", "fSubscribeOn", "fPush"].indexOf(vMain.func) == -1) return vCRes;
    if (vMain.func == "fDump") {
        v = vMain.xml.find("res>param>nodes>node");
        vCRes.aNode = [];
        for (i = 0; i < v.length; i++) {
            v0 = $(v[i]);
            v1 = { urn: v0.attr("urn"), bDyn: +v0.attr("bDyn"), ttl: v0.attr("ttl"), aMsg: [], aSubscr: [] };
            vCRes.aNode[i] = v1;
            str = v0.find("msg").attr("list");
            if (str != "") v1.aMsg = str.split(";");
            str = v0.find("subscr").attr("list");
            if (str != "") v1.aSubscr = str.split(";");
        }
    } else if (vMain.func == "fPost") {
        vCRes.guidMsg = vMain.xml.find("res>param>info").attr("guid");
    } else if (vMain.func == "fReadNext" || vMain.func == "fPush") {
        v = vMain.xml.find("res>param>info");
        if (v.length) {
            vCRes.msg = {
                guid: v.attr("guid"),
                dt: v.attr("dt"),
                sn: v.attr("sn"),
                sender: v.attr("sender"),
                audience: v.attr("audience"),
                tags: v.attr("tags"),
                bBubble: +v.attr("bBubble"),
                bRcvOnce: +v.attr("bRcvOnce"),
                body: vMain.xml.find("res>param>body").text(),
            };
            v = vMain.xml.find("res>param>node");
            vCRes.msg.node = { urn: v.attr("urn"), ttl: v.attr("ttl") };
        }
    } else if (vMain.func == "fSubscribeOn") {
        vCRes.guidSubscr = vMain.xml.find("res>param>info").attr("guidUrn");
        this.m_vHashSubscr[vCRes.guidSubscr] = this.m_fOkPush;
    }
    if (vMain.func == "fPush") return this.m_vHashSubscr[vMain.guidSubscr](vCRes);
    return vCRes;
};

portima.wsk.ws.msg.CConnSess.prototype.fPushChck = function (vCRes) {
    const vMain = vCRes.main;
    if (vMain.func != "fPush") return null;
    return vMain.xml.find("res>param>info").attr("guidSubscr");
};
// WS API
portima.wsk.ws.msg.CConnSess.prototype.fWsDump = function (urn) {
    const str = this.fQuery(this.m_gaQuery.fDump).fmt(urn);
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsMsgDelete = function (guid) {
    if (!guid) return this.fErrInReq("fWsMsgDelete", "empty guid", "applicative");
    const str = portima.wsk.fQuery(this.m_gaQuery.fMsgDelete).fmt(guid);
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsNodeCreate = function (urn, ttl) {
    if (!ttl) ttl = "";
    const str = this.fQuery(this.m_gaQuery.fNodeCreate).fmt(urn, ttl);
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsNodeDelete = function (urn) {
    const str = this.fQuery(this.m_gaQuery.fNodeDelete).fmt(urn);
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsPost = function (urn, body, param) {
    urn = urn || "";
    param = param || {};

    param.bRcvOnce = param.bRcvOnce == undefined ? 0 : param.bRcvOnce;
    param.bMustExist = param.bMustExist == undefined ? 1 : param.bMustExist;
    param.bBubble = param.bBubble == undefined ? 0 : param.bBubble;
    const str = this.fQuery(this.m_gaQuery.fPost).fmt(
        urn,
        param.bRcvOnce,
        param.bMustExist,
        param.bBubble,
        param.tags ? param.tags : "",
        param.audience ? param.audience : "",
        param.sender ? param.sender : "me",
        body || "",
    );
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsReadNext = function (urn, param) {
    urn = urn || "";
    param = param || {};

    param.bBubbledMsg = param.bBubbledMsg == undefined ? 0 : param.bBubbledMsg;
    const str = this.fQuery(this.m_gaQuery.fReadNext).fmt(
        urn,
        param.bBubbledMsg,
        param.filterTag ? param.filterTag : "",
        param.filterSender ? param.filterSender : "",
        param.who ? param.who : "",
        param.dt ? param.dt : "",
        param.sn ? param.sn : "",
    );
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsSubscribeOff = function (guidUrn) {
    if (!guidUrn) return this.fErrInReq("fWsSubscribeOff", "empty guidUrn", "applicative");
    delete this.m_vHashSubscr[guidUrn];
    const str = this.fQuery(this.m_gaQuery.fSubscribeOff).fmt(guidUrn);
    return this.fReq(str);
};
portima.wsk.ws.msg.CConnSess.prototype.fWsSubscribeOn = function (urn, param, fOk) {
    urn = urn || "";
    param = param || {};

    this.m_fOkPush = fOk;
    param.bBubbledMsg = param.bBubbledMsg == undefined ? 0 : param.bBubbledMsg;
    const str = this.fQuery(this.m_gaQuery.fSubscribeOn).fmt(
        urn,
        param.bBubbledMsg,
        param.filterTag ? param.filterTag : "",
        param.filterSender ? param.filterSender : "",
        param.who ? param.who : "me",
    );
    return this.fReq(str);
};

// XML API
portima.wsk.ws.msg.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/msg";
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fDump = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fDump",
    param: '<info urn="{0}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fMsgDelete = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fMsgDelete",
    param: '<info guid="{0}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fNodeCreate = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fNodeCreate",
    param: '<info urn="{0}" ttl="{1}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fNodeDelete = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fNodeDelete",
    param: '<info urn="{0}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fPost = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fPost",
    param:
        '<info urn="{0}" bRcvOnce="{1}" bMustExist="{2}" bBubble="{3}" tags="{4}" audience="{5}"' +
        ' sender="{6}"/><body><![CDATA[{7}]]></body>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fReadNext = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fReadNext",
    param: '<info urn="{0}" bBubbledMsg="{1}" filterTag="{2}" filterSender="{3}" who="{4}" dtLast="{5}" snLast="{6}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fSubscribeOff = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fSubscribeOff",
    param: '<info guidUrn="{0}"/>',
};
portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery.fSubscribeOn = {
    ns: portima.wsk.ws.msg.CConnSess.prototype.m_gNs,
    func: "fSubscribeOn",
    param: '<info urn="{0}" bBubbledMsg="{1}" filterTag="{2}" filterSender="{3}" who="{4}"/>',
};
// FILE--7/29/2019 09:41:16--wskWsMsgCloud

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.msg = portima.wsk.ws.msg || {};
portima.wsk.ws.msg.cloud = portima.wsk.ws.msg.cloud || {};

// portima.wsk.ws.msg.cloud.CConnSess
portima.wsk.ws.msg.cloud.CConnSess = function portimaWskWsMsgCloudCConnSess() {
    portima.wsk.ws.msg.CConnSess.call(this);
    this.m_tcp = 10200;
    // this.m_ip = "cloud.wsk.portima.be"; as soon as we have a globalSign cert or a strong portima CA chain
    this.m_ns = "http://www.portima.com/pki/identity/pi2/cloud/global/msg";
};

portima.wsk.ws.msg.cloud.CConnSess.prototype = createObject(portima.wsk.ws.msg.CConnSess.prototype);
portima.wsk.ws.msg.cloud.CConnSess.prototype.constructor = portima.wsk.ws.msg.cloud.CConnSess;

portima.wsk.ws.msg.cloud.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let i;
    let str;
    let v;
    let v0;
    let v1;
    const vMain = vCRes.main;

    if (["fDump", "fPost", "fReadNext", "fSubscribeOn", "fPush"].indexOf(vMain.func) == -1) return vCRes;
    vCRes.inst = vMain.xml.find("res>param>infoInst").attr("inst");
    if (vMain.func == "fDump") {
        v = vMain.xml.find("res>param>nodes>node");
        vCRes.aNode = [];
        for (i = 0; i < v.length; i++) {
            v0 = $(v[i]);
            v1 = { urn: v0.attr("urn"), aSubscr: [] };
            vCRes.aNode[i] = v1;
            str = v0.find("subscr").attr("list");
            if (str != "") v1.aSubscr = str.split(";");
        }
    } else if (vMain.func == "fPost") {
        vCRes.guidMsg = vMain.xml.find("res>param>info").attr("guid");
    } else if (vMain.func == "fReadNext" || vMain.func == "fPush") {
        v = vMain.xml.find("res>param>info");
        if (v.length) {
            vCRes.msg = {
                guid: v.attr("guid"),
                urn: v.attr("urn"),
                dt: v.attr("dt"),
                sn: v.attr("sn"),
                body: vMain.xml.find("res>param>body").text(),
                to: vMain.xml.find("res>param>to").text(),
                tag: vMain.xml.find("res>param>tag").text(),
                from: vMain.xml.find("res>param>from").text(),
                bBubble: +v.attr("bBubble"),
                bTag: +v.attr("bTag"),
                nReadMax: +v.attr("nReadMax"),
                nRead: +v.attr("nRead"),
            };
        }
    } else if (vMain.func == "fSubscribeOn") {
        vCRes.guidSubscr = vMain.xml.find("res>param>info").attr("guidUrn");
        this.m_vHashSubscr[vCRes.guidSubscr] = this.m_fOkPush;
    }
    if (vMain.func == "fPush") return this.m_vHashSubscr[vMain.guidSubscr](vCRes);
    return vCRes;
};

// XML API

portima.wsk.ws.msg.cloud.CConnSess.prototype.fWsPost = function (urn, body, param) {
    urn = urn || "";
    param = param || {};

    param.nReadMax = param.nReadMax == undefined || param.nReadMax == "" ? "-1" : param.nReadMax;
    param.bBubble = param.bBubble == undefined ? 0 : param.bBubble;
    param.bTag = param.bTag == undefined ? 0 : param.bTag;
    const str = this.fQuery(this.m_gaQuery.fPost).fmt(
        urn,
        param.from ? param.from : "",
        param.to ? param.to : "",
        param.nReadMax,
        param.bBubble,
        param.bTag,
        param.tag ? param.tag : "",
        param.siblings ? param.siblings : "",
        body || "",
    );
    return this.fReq(str);
};

portima.wsk.ws.msg.cloud.CConnSess.prototype.m_gaQuery = {
    ...portima.wsk.ws.msg.CConnSess.prototype.m_gaQuery,
};

portima.wsk.ws.msg.cloud.CConnSess.prototype.m_gaQuery.fPost = {
    ns: null,
    func: "fPost",
    param:
        '<info urn="{0}" who="{1}" to="{2}" nReadMax="{3}" bBubble="{4}" bTag="{5}" tag="{6}"' +
        ' siblings="{7}"/><body><![CDATA[{8}]]></body>',
};

// FILE--7/29/2019 09:41:16--wskWsPkgCieExch

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.pkgCieExch = portima.wsk.ws.pkgCieExch || {};
portima.wsk.ws.pkgCieExch.mobile = portima.wsk.ws.pkgCieExch.mobile || {};

// portima.wsk.ws.pkgCieExch.CConnSess
portima.wsk.ws.pkgCieExch.CConnSess = function portimaWskWsPkgCieExchCConnSess() {
    portima.wsk.CConnSess.call(this);
    this.m_strUrlPackage = "";
    this.m_bMobile = undefined;
    this.m_vPortimaWskCConnSessMsg = null;
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.pkgCieExch.CConnSess.prototype.constructor = portima.wsk.ws.pkgCieExch.CConnSess;

portima.wsk.ws.pkgCieExch.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    let v;
    const vMain = vCRes.main;

    if (
        [
            "fContextConfig",
            "fContextInitQueryQuit",
            "fContextStateInit",
            "fContextStateQuery",
            "fExplorerInvoke",
            "fExplorerIsAvailable",
            "fExplorerParamsGet",
        ].indexOf(vMain.func) == -1
    )
        return vCRes;
    if (vMain.func == "fContextInitQueryQuit" || vMain.func == "fContextStateQuery")
        vCRes.response = vMain.xml.find("res>param>response").text();
    else if (vMain.func == "fContextStateInit") vCRes.guid = vMain.xml.find("res > param > response").attr("guid");
    else if (vMain.func == "fExplorerParamsGet") {
        v = vMain.xml.find("res>param>info");
        vCRes.params = {
            cc: v.attr("cc"),
            oc: v.attr("oc"),
            oac: v.attr("oac"),
            d: v.attr("d"),
            up: v.attr("up"),
            ProductCode: v.attr("ProductCode"),
            TypePolicyCode: v.attr("TypePolicyCode"),
            MultiSessionId: v.attr("MultiSessionId"),
            Multi: v.attr("Multi") == 1,
        };
    } else if (vMain.func == "fExplorerInvoke") {
        v = vMain.xml.find("res>param>info");
        vCRes.params = { b: v.attr("b") == 1 };
    } else if (vMain.func == "fExplorerIsAvailable") {
        v = vMain.xml.find("res>param>info");
        vCRes.params = { b: v.attr("b") == 1 };
    } else if (vMain.func == "fContextConfig") {
        v = vMain.xml.find("res>param>info");
        vCRes.params = {
            ctxClass: v.attr("ctxClass"),
            bCtxRunning: v.attr("bCtxRunning") == 1,
            bGoblins: v.attr("bGoblins") == 1,
            browser: v.attr("browser"),
            url: v.attr("url"),
        };
        if (v.attr("o")) {
            vCRes.params.sso = { o: v.attr("o"), so: v.attr("so"), user: v.attr("user"), lang: v.attr("lang") };
        }
    }
    return vCRes;
};
// WS API

portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextConfig = function (bSso) {
    this.m_vDeferred = null;
    bSso = bSso ? 1 : 0;
    const str = portima.wsk.fQuery(this.m_gaQuery.fContextConfig).fmt(bSso);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextInitQueryQuit = function (query) {
    if (portima.main.isMobile.any(this.m_bMobile)) return this.fContextStateQuery("fake", query);
    const str = portima.wsk.fQuery(this.m_gaQuery.fContextInitQueryQuit).fmt(query);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextPkgQueryGet = function (guid, aFilter, bSubscribeOff) {
    const self = this;
    let vPortimaWskCConnSess;
    const def = $.Deferred();

    if (bSubscribeOff == undefined) bSubscribeOff = true;
    if (portima.main.isMobile.any(this.m_bMobile)) {
        vPortimaWskCConnSess = new portima.wsk.ws.pkgCieExch.facade.CConnSess();
        vPortimaWskCConnSess.fQueryGet(guid).then(
            function (vCRes) {
                def.resolveWith(self, [vCRes]);
            },
            function (vCErr) {
                def.rejectWith(self, [vCErr]);
            },
        );
        return def.promise();
    }
    if (!this.m_vPortimaWskCConnSessMsg) this.m_vPortimaWskCConnSessMsg = new portima.wsk.ws.msg.CConnSess();
    if (!aFilter) aFilter = ["query"];
    else if (aFilter == "*") aFilter = ["init", "quit", "reset", "query"];
    else if (aFilter == "ctl") aFilter = ["init", "quit", "reset"];
    this.m_vPortimaWskCConnSessMsg.m_vCtxt = { connCieExch: this, def, aFilter };
    this.m_vPortimaWskCConnSessMsg
        .fWsSubscribeOn("portima.exchContext.query", { bBubbledMsg: 0 }, function (vCRes) {
            const { ctxt } = vCRes.main;

            if (portima.wsk.fVerCheck({ e: "0", w: "0.81" })) {
                if (ctxt.aFilter.indexOf("query") < 0) return;
                vCRes.query = vCRes.msg.body;
            } else {
                let q;

                q = $($.parseXML(vCRes.msg.body)).find("q");
                vCRes.cmd = { urn: q.attr("urn"), guid: q.attr("guid") };
                if (vCRes.cmd.urn == "init") vCRes.cmd.guidSess = q.attr("guidSess");
                else if (vCRes.cmd.urn == "query") vCRes.query = q.text();
                if (ctxt.aFilter.indexOf(vCRes.cmd.urn) < 0) return;
            }
            ctxt.def.resolveWith(ctxt.connCieExch, [vCRes]);
            if (bSubscribeOff)
                ctxt.connCieExch.m_vPortimaWskCConnSessMsg.fWsSubscribeOff(vCRes.main.guidSubscr).then(
                    function () {},
                    function () {},
                );
        })
        .then(
            function (vCRes) {
                this.m_vCtxt.guidSubscr = vCRes.guidSubscr;
            },
            function (vCErr) {
                this.m_vCtxt.def.rejectWith(this.m_vCtxt.connCieExch, [vCErr]);
            },
        );
    return def.promise();
};

portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextPkgCmdListen = function (aFilter, handler) {
    let guidLog;
    const self = this;
    const def = $.Deferred();

    guidLog = portima.main.generateUUID();
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
        console.log(
            "pkgCieExch::fContextPkgCmdListen_B guidLog=%s aFilter=[%o] handler=[%o]",
            guidLog,
            aFilter,
            handler,
        );
    if (!this.m_vPortimaWskCConnSessMsg) this.m_vPortimaWskCConnSessMsg = new portima.wsk.ws.msg.CConnSess();
    if (this.m_guidSubscr) this.m_vPortimaWskCConnSessMsg.fWsSubscribeOff(this.m_guidSubscr);
    this.m_guidSubscr = "";
    if (!handler) {
        def.resolveWith(this, null);
        this.m_vPortimaWskCConnSessMsg.fCloseSilent();
        return def.promise();
    }
    if (!aFilter) aFilter = ["query"];
    else if (aFilter == "*") aFilter = ["init", "quit", "reset", "query"];
    else if (aFilter == "ctl") aFilter = ["init", "quit", "reset"];
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
        console.log("pkgCieExch::fContextPkgCmdListen guidLog=%s fWsSubscribeOn B", guidLog);
    this.m_vPortimaWskCConnSessMsg
        .fWsSubscribeOn("portima.exchContext.query", { bBubbledMsg: 0 }, function (vCRes) {
            if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                console.log("pkgCieExch::fContextPkgCmdListen guidLog=%s query pushed=[%o]", guidLog, vCRes);
            if (portima.wsk.fVerCheck({ e: "0", w: "0.81" })) {
                if (aFilter.indexOf("query") < 0) return;
                vCRes.query = vCRes.msg.body;
            } else {
                let q;

                q = $($.parseXML(vCRes.msg.body)).find("q");
                vCRes.cmd = { urn: q.attr("urn"), guid: q.attr("guid") };
                if (vCRes.cmd.urn == "init") vCRes.cmd.guidSess = q.attr("guidSess");
                else if (vCRes.cmd.urn == "query") vCRes.query = q.text();
                if (aFilter.indexOf(vCRes.cmd.urn) < 0) return;
            }
            if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                console.log("pkgCieExch::fContextPkgCmdListen guidLog=%s handler calling", guidLog);
            handler(vCRes);
        })
        .then(
            function (vCRes) {
                if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                    console.log(
                        "pkgCieExch::fContextPkgCmdListen guidLog=%s fWsSubscribeOn solved=[%o]",
                        guidLog,
                        vCRes,
                    );
                self.m_guidSubscr = vCRes.guidSubscr;
                def.resolveWith(self, [vCRes]);
            },
            function (vCErr) {
                if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                    console.log(
                        "pkgCieExch::fContextPkgCmdListen guidLog=%s fWsSubscribeOn failed=[%o]",
                        guidLog,
                        vCErr,
                    );
                def.rejectWith(self, [vCErr]);
            },
        );
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
        console.log("pkgCieExch::fContextPkgCmdListen_E guidLog=%s", guidLog);
    return def.promise();
};

portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextPkgResponsePost = function (guid, response, guidQuery) {
    let guidLog;
    const self = this;

    guidLog = portima.main.generateUUID();
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
        console.log(
            "pkgCieExch::fContextPkgResponsePost_B guidLog=%s guid=[%s] response=[%s] guidQuery=[%s]",
            guidLog,
            guid,
            response,
            guidQuery,
        );
    if (portima.main.isMobile.any(this.m_bMobile)) {
        let vPortimaWskCConnSess;
        var def = $.Deferred();
        vPortimaWskCConnSess = new portima.wsk.ws.pkgCieExch.facade.CConnSess();
        vPortimaWskCConnSess.fResponsePost(guid, response).then(
            function (vCRes) {
                def.resolveWith(self, [vCRes]);
            },
            function (vCErr) {
                def.rejectWith(self, [vCErr]);
            },
        );
        return def.promise();
    }
    if (!this.m_vPortimaWskCConnSessMsg) this.m_vPortimaWskCConnSessMsg = new portima.wsk.ws.msg.CConnSess();
    if (!guidQuery) guidQuery = "NA";
    let p;
    var def;

    def = $.Deferred().resolveWith("");
    p = def.promise();
    def = $.Deferred();
    p.then(function () {
        if (portima.wsk.m_gvCurrent) return "";

        const vCConnSess = new portima.wsk.ws.sso.CConnSess();
        if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
            console.log("pkgCieExch::fContextPkgResponsePost guidLog=%s fEcho", guidLog);
        return vCConnSess.fEcho("fake call");
    })
        .then(function () {
            let bRcvOnce;
            const bNew = !portima.wsk.fVerCheck({ e: "0", w: "0.81" });
            if (bNew) {
                bRcvOnce = 1;
                // response = "<r guid=\"{0}\"><![CDATA[{1}]]]]><![CDATA[></r>".fmt(guidQuery, response);
                response = '<r guid="{0}">{1}</r>'.fmt(guidQuery, response.encodeHTML());
                // encodeHTML
            }
            if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                console.log(
                    "pkgCieExch::fContextPkgResponsePost guidLog=%s posting response response=[%s]",
                    guidLog,
                    response,
                );
            return self.m_vPortimaWskCConnSessMsg.fWsPost("portima.exchContext.response", response, {
                bRcvOnce,
            });
        })
        .then(
            function (vCRes) {
                if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                    console.log("pkgCieExch::fContextPkgResponsePost guidLog=%s succeeded=[%o]", guidLog, vCRes);
                def.resolveWith(self, [vCRes]);
            },
            function (vCErr) {
                if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
                    console.log("pkgCieExch::fContextPkgResponsePost guidLog=%s failed=[%o]", guidLog, vCErr);
                def.rejectWith(self, [vCErr]);
            },
        );
    if (portima.main.log.LEVELS.debug >= portima.main.log.levelMin)
        console.log("pkgCieExch::fContextPkgResponsePost_E guidLog=%s", guidLog);
    return def.promise();
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextReset = function (guid) {
    let str = !guid ? "" : ' guid="{0}"'.fmt(guid);
    str = portima.wsk.fQuery(this.m_gaQuery.fContextReset).fmt(str);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextStateInit = function (guid) {
    if (portima.main.isMobile.any(this.m_bMobile)) {
        const v = $.Deferred();
        const vCRes = { guid: "fake", main: {} };
        vCRes.main = {
            ctxt: this.m_ctxt,
            func: "fContextStateInit",
            ns: "http://www.portima.com/asweb/test",
            reqRaw: null,
            resRaw: null,
            xml: null,
        };
        v.resolveWith(this, [vCRes]);
        return v.promise();
    }
    let str = !guid ? "" : ' guidSess="{0}"'.fmt(guid);
    str = portima.wsk.fQuery(this.m_gaQuery.fContextStateInit).fmt(str);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextStateQuery = function (guid, query) {
    if (portima.main.isMobile.any(this.m_bMobile))
        return portima.wsk.ws.pkgCieExch.mobile.fContextStateQuery(this, guid, query);
    const str = portima.wsk.fQuery(this.m_gaQuery.fContextStateQuery).fmt(guid, query);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fContextStateQuit = function (guid) {
    if (portima.main.isMobile.any(this.m_bMobile)) {
        const v = $.Deferred();
        const vCRes = {};
        vCRes.main = {
            ctxt: this.m_ctxt,
            func: "fContextStateQuit",
            ns: "http://www.portima.com/asweb/test",
            reqRaw: null,
            resRaw: null,
            xml: null,
        };
        v.resolveWith(this, [vCRes]);
        return v.promise();
    }
    const str = portima.wsk.fQuery(this.m_gaQuery.fContextStateQuit).fmt(guid);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fExplorerInvoke = function () {
    const str = portima.wsk.fQuery(this.m_gaQuery.fExplorerInvoke);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fExplorerInvokeOff = function () {
    const str = portima.wsk.fQuery(this.m_gaQuery.fExplorerInvokeOff);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fExplorerIsAvailable = function () {
    const str = portima.wsk.fQuery(this.m_gaQuery.fExplorerIsAvailable);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fExplorerParamsGet = function () {
    const str = portima.wsk.fQuery(this.m_gaQuery.fExplorerParamsGet);
    return this.fReq(str);
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.fExplorerParamsSet = function (cc, oc, oac, d, up, extra) {
    let str = "";

    if (cc) str += 'cc="{0}" '.fmt(cc);
    if (oc) str += 'oc="{0}" '.fmt(oc);
    if (oac) str += 'oac="{0}" '.fmt(oac);
    if (d) str += 'd="{0}" '.fmt(d);
    if (up != undefined) str += 'up="{0}" '.fmt(up);
    if (extra && extra.ProductCode != undefined) str += 'ProductCode="{0}" '.fmt(extra.ProductCode);
    if (extra && extra.TypePolicyCode != undefined) str += 'TypePolicyCode="{0}" '.fmt(extra.TypePolicyCode);
    if (extra && extra.Multi != undefined) str += 'Multi="{0}" '.fmt(extra.Multi ? 1 : 0);
    if (extra && extra.MultiSessionId != undefined) str += 'MultiSessionId="{0}" '.fmt(extra.MultiSessionId);
    if (str) str = "<info {0}/>".fmt(str);
    str = portima.wsk.fQuery(this.m_gaQuery.fExplorerParamsSet).fmt(str);
    return this.fReq(str);
};

// XML API
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs =
    "http://www.portima.com/pki/identity/pi2/local/asweb/sess/pkgCieExch";
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery = {};

portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextConfig = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextConfig",
    param: '<info bSso="{0}"/>',
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextInitQueryQuit = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextInitQueryQuit",
    param: "<query><![CDATA[{0}]]></query>",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextReset = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextReset",
    param: "<query{0}/>",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextStateInit = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextStateInit",
    param: "<query{0}/>",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextStateQuery = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextStateQuery",
    param: '<query guid="{0}"><![CDATA[{1}]]></query>',
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fContextStateQuit = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fContextStateQuit",
    param: '<query guid="{0}"/>',
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fExplorerInvoke = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fExplorerInvoke",
    param: "",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fExplorerInvokeOff = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fExplorerInvokeOff",
    param: "",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fExplorerIsAvailable = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fExplorerIsAvailable",
    param: "",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fExplorerParamsGet = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fExplorerParamsGet",
    param: "",
};
portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gaQuery.fExplorerParamsSet = {
    ns: portima.wsk.ws.pkgCieExch.CConnSess.prototype.m_gNs,
    func: "fExplorerParamsSet",
    param: "{0}",
};

// private

portima.wsk.ws.pkgCieExch.mobile.fContextStateQuery = function (vCConn, guid, query) {
    let vPortimaWskCConnSess;
    const def = $.Deferred();
    vPortimaWskCConnSess = new portima.wsk.ws.pkgCieExch.facade.CConnSess();
    vPortimaWskCConnSess.m_ctxt = { def, vCConn };
    vPortimaWskCConnSess
        .fQueryPost(query)
        .then(
            portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryOk,
            portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryErr,
        );
    return def.promise();
};
portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryErr = function (vCErr) {
    this.m_ctxt.def.rejectWith(this.m_ctxt.vCConn, [vCErr]);
};
portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryOk = function (vCRes) {
    if (vCRes.main.func == "fQueryPost")
        this.m_ctxt.vCConn.m_hwnd = portima.wsk.CConn.prototype.onopen(
            `${this.m_ctxt.vCConn.m_strUrlPackage}guid=${vCRes.guid}`,
            "packageWindow",
        );
    this.m_ctxt.vCConn.m_timeoutId = setTimeout(
        (function (x, y) {
            return function () {
                x.fResponseGet(y).then(function (vCRes) {
                    if (vCRes.response) {
                        vCRes.main.ctxt = this.m_ctxt.vCConn.m_ctxt;
                        vCRes.main.func = "fContextStateQuery";
                        this.m_ctxt.def.resolveWith(this.m_ctxt.vCConn, [vCRes]);
                        return;
                    }
                    portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryOk.call(this, vCRes);
                }, portima.wsk.ws.pkgCieExch.mobile.fContextStateQueryErr);
            };
        })(this, this.m_guid),
        vCRes.poolSec * 1000,
    );
};
// FILE--7/29/2019 09:41:16--wskWsPkgCieExchFacade

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.pkgCieExch = portima.wsk.ws.pkgCieExch || {};
portima.wsk.ws.pkgCieExch.facade = portima.wsk.ws.pkgCieExch.facade || {};

portima.wsk.ws.pkgCieExch.facade.CConnSess = function portimaWskWsPkgCieExchFacadeCConnSess() {
    this.m_ctxt = null;
    this.m_guid = null;
};

// WS API
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fContextStateQuery = function (guid) {};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fQueryGet = function (guid) {
    console.log("%s:fQueryGet %s", this.constructor.name, guid);
    this.m_guid = guid;
    const str = this.m_gQuery.fmt("CtxExch", "QueryGet", "&lt;Guid&gt;{0}&lt;/Guid&gt;".fmt(guid));
    this.m_strFunc = "fQueryGet";
    return this.fExchange(str);
};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fQueryPost = function (query) {
    console.log("%s:fQueryPost %s", this.constructor.name, query);
    const str = this.m_gQuery.fmt("CtxExch", "QueryPost", "&lt;Query&gt;{0}&lt;/Query&gt;".fmt(query));
    this.m_strFunc = "fQueryPost";
    return this.fExchange(str);
};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fResponseGet = function (guid) {
    console.log("%s:fResponseGet %s", this.constructor.name, guid);
    this.m_guid = guid;
    const str = this.m_gQuery.fmt("CtxExch", "ResponseGet", "&lt;Guid&gt;{0}&lt;/Guid&gt;".fmt(guid));
    this.m_strFunc = "fResponseGet";
    return this.fExchange(str);
};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fResponsePost = function (guid, response) {
    console.log("%s:fResponsePost %s res=[%s]", this.constructor.name, guid, response);
    this.m_guid = guid;
    const str = this.m_gQuery.fmt(
        "CtxExch",
        "ResponsePost",
        "&lt;Guid&gt;{0}&lt;/Guid&gt;&lt;Response&gt;{1}&lt;/Response&gt;".fmt(guid, response),
    );
    this.m_strFunc = "fResponsePost";
    return this.fExchange(str);
};

// XML API

portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.m_gUrl = "pi2/Sp/Portima/bsFacadeAswebWs/wsAswebWs.asmx";
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.m_gQuery =
    '<?xml version="1.0"?>' +
    '<SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" ' +
    'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><SOAP-ENV:Body><Exchange xmlns="http://www.portima.com/asweb/test">' +
    '<Request>&lt;?xml version="1.0"?&gt;&lt;ASWeb OfficeID="" SubOfficeID="" User="" UserRoles="" Version="1.0"&gt;' +
    '&lt;Service Name="{0}" _Mode="async" State="post"&gt;&lt;Request Name="{1}" ID="1"&gt;{2}' +
    "&lt;/Request&gt;&lt;/Service&gt;&lt;/ASWeb&gt;" +
    "</Request></Exchange></SOAP-ENV:Body></SOAP-ENV:Envelope>";

// private
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fErr = function (jqXHR, textStatus, x) {
    const vCErr = portima.wsk.CConn.prototype.fErr.call(
        this,
        this.m_strFunc,
        "{0}:{1}".fmt(jqXHR.status, jqXHR.statusText),
    );
    console.log("%s:fErr %o", this.constructor.name, vCErr);
    this.m_vDeferred.rejectWith(this, [vCErr]);
};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fOk = function (data) {
    console.log("%s:fOk RES:", this.constructor.name, data.documentElement.outerHTML);
    const $xml = $($.parseXML($(data).find("Body").text()));
    const vCRes = {};
    var v;
    vCRes.main = {
        ctxt: this.m_ctxt,
        func: this.m_strFunc,
        ns: "http://www.portima.com/asweb/test",
        reqRaw: this.m_req,
        resRaw: data.documentElement.outerHTML,
        xml: $xml,
    };
    var v = $xml.find("ASWeb > Response > Errors > Error");
    if (v.length) {
        const v0 = `${v.find("Code").text()}::${v.find("Detail").text()}`;
        const vCErr = portima.wsk.CConn.prototype.fErr.call(this, this.m_strFunc, v0, "applicative");
        console.log("%s:fOk applicative error %o", this.constructor.name, vCErr);
        this.m_vDeferred.rejectWith(this, [vCErr]);
        return;
    }
    switch (this.m_strFunc) {
        case "fQueryGet": {
            vCRes.query = $xml.find("Query").text();
            break;
        }
        case "fQueryPost": {
            vCRes.guid = $xml.find("Guid").text();
            this.m_guid = vCRes.guid;
            v = $xml.find("ResponsePooling");
            vCRes.poolSec = v.text();
            break;
        }
        case "fResponseGet": {
            v = $xml.find("ResponsePooling");
            if (v.length) vCRes.poolSec = v.text();
            else vCRes.response = $xml.find("Response > Response").text();
            break;
        }
    }
    this.m_vDeferred.resolveWith(this, [vCRes]);
};
portima.wsk.ws.pkgCieExch.facade.CConnSess.prototype.fExchange = function (str) {
    const self = this;
    this.m_req = str;
    console.log("%s:fExchange REQ:", this.constructor.name, str);
    $.ajax({
        url: this.m_gUrl,
        type: "POST",
        headers: {
            SOAPAction: "http://www.portima.com/asweb/test/Exchange",
            "Content-Type": 'text/xml; charset="utf-8"',
        },
        data: str,
        dataType: "xml",
    }).then(
        function (data) {
            self.fOk(data);
        },
        function (jqXHR, textStatus, x) {
            self.fErr(jqXHR, textStatus, x);
        },
    );
    this.m_vDeferred = $.Deferred();
    return this.m_vDeferred.promise();
};
// FILE--7/29/2019 09:41:16--wskWsSso

portima.wsk.ws = portima.wsk.ws || {};
portima.wsk.ws.sso = portima.wsk.ws.sso || {};

// portima.wsk.ws.sso.CConnSess
portima.wsk.ws.sso.CConnSess = function portimaWskWsSsoCConnSess() {
    portima.wsk.CConnSess.call(this);
};
portima.wsk.ws.sso.CConnSess.prototype = createObject(portima.wsk.CConnSess.prototype);
portima.wsk.ws.sso.CConnSess.prototype.constructor = portima.wsk.ws.sso.CConnSess;

portima.wsk.ws.sso.CConnSess.prototype.fResultUpdateOk = function (vCRes) {
    const vMain = vCRes.main;

    if (vMain.func == "fEcho") vCRes.response = vMain.xml.find("res > param").text();
    else if (vMain.func == "fTokenGet") vCRes.artifact = vMain.xml.find("res > param").text();
    return vCRes;
};

// WS API
portima.wsk.ws.sso.CConnSess.prototype.fEcho = function (query) {
    const str = portima.wsk.fQuery(this.m_gaQuery.fEcho).fmt(query);
    return this.fReq(str);
};
portima.wsk.ws.sso.CConnSess.prototype.fLaunch = function (query) {
    const str = portima.wsk.fQuery(this.m_gaQuery.fLaunch).fmt(query);
    return this.fReq(str);
};
portima.wsk.ws.sso.CConnSess.prototype.fLaunchUrl = function (url) {
    const str = portima.wsk.fQuery(this.m_gaQuery.fLaunchUrl).fmt(url);
    return this.fReq(str);
};
portima.wsk.ws.sso.CConnSess.prototype.fTokenGet = function (sp, o, so, query) {
    const str = portima.wsk.fQuery(this.m_gaQuery.fTokenGet).fmt(sp, o, so, query);
    return this.fReq(str);
};

// XML API
portima.wsk.ws.sso.CConnSess.prototype.m_gNs = "http://www.portima.com/pki/identity/pi2/local/asweb/sess/sso";
portima.wsk.ws.sso.CConnSess.prototype.m_gaQuery = {};
portima.wsk.ws.sso.CConnSess.prototype.m_gaQuery.fEcho = {
    ns: portima.wsk.ws.sso.CConnSess.prototype.m_gNs,
    func: "fEcho",
    param: "{0}",
};
portima.wsk.ws.sso.CConnSess.prototype.m_gaQuery.fLaunch = {
    ns: portima.wsk.ws.sso.CConnSess.prototype.m_gNs,
    func: "fLaunch",
    param: "<query><![CDATA[{0}]]></query>",
};
portima.wsk.ws.sso.CConnSess.prototype.m_gaQuery.fLaunchUrl = {
    ns: portima.wsk.ws.sso.CConnSess.prototype.m_gNs,
    func: "fLaunchUrl",
    param: "<url><![CDATA[{0}]]></url>",
};
portima.wsk.ws.sso.CConnSess.prototype.m_gaQuery.fTokenGet = {
    ns: portima.wsk.ws.sso.CConnSess.prototype.m_gNs,
    func: "fTokenGet",
    param: '<info sp="{0}" _o="{1}" _so="{2}"/><query><![CDATA[{3}]]></query>',
};

export default portima;
